import { createSlice } from "@reduxjs/toolkit";

export const LoadingSlice = createSlice({
  name: "Loading",
  initialState: {
    isLoading: false,
  },
  reducers: {
    setIsLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
  },
});

export const { setIsLoading } = LoadingSlice.actions;

export const LoadingReducer = LoadingSlice.reducer;
